<template lang="pug">
.div
  h2.title Products Integration

  .form-section
    .input-container
      label.label Choose File
      input.input(ref="input" type="file" accept=".csv" autocomplete="ño" required)
      div(@click="readFile") Read File
      div {{ message }}
</template>

<script>
import gql from '@my/graphql'
import gqlProduct from '@/graphql/product'

export default {
  name: 'ProductsIntegration',

  data () {
    return {
      message: '',
      csv: '',
      titleNames: { product: 0, oldProduct: 1, person: 2, article: 3, design: 4, color1: 5, color2: 6, color3: 7, image1: 8, image2: 9, image3: 10, image4: 11, image5: 12, measurementsImage: 13, priceUnit: 14, priceThree: 15, priceWholesaler: 16, description: 17 },
      products: {}
    }
  },

  methods: {
    readFile () {
      if (!this.$refs.input.files.length) return
      const file = this.$refs.input.files[0]
      const reader = new FileReader()
      this.message = 'Cargando...'
      reader.onload = () => {
        this.csv = reader.result
        this.message = 'Cargado'
        this.csvToObject()
      }
      reader.readAsText(file)
    },

    async csvToObject () {
      const _ = this.titleNames
      const lines = this.csv.split('\r\n')

      for (let i = 1; i < lines.length; i++) {
        const line = lines[i]
        const values = line.split(';')
        if (!values[_.product]) continue

        const product = { product: values[_.product], oldProduct: values[_.oldProduct], person: values[_.person], article: values[_.article], design: values[_.design], measurementsImage: values[_.measurementsImage], priceUnit: parseInt(values[_.priceUnit]), priceThree: parseInt(values[_.priceThree]), priceWholesaler: parseInt(values[_.priceWholesaler]), description: values[_.description], active: true, folder: 'products', subfolder: values[_.person], colors: [], images: [], priceSale: 0 }

        if (values[_.color1]) product.colors.push(values[_.color1])
        if (values[_.color2]) product.colors.push(values[_.color2])
        if (values[_.color3]) product.colors.push(values[_.color3])

        if (values[_.image1]) product.images.push(`${values[_.image1]}.jpg`)
        if (values[_.image2]) product.images.push(`${values[_.image2]}.jpg`)
        if (values[_.image3]) product.images.push(`${values[_.image3]}.jpg`)
        if (values[_.image4]) product.images.push(`${values[_.image4]}.jpg`)
        if (values[_.image5]) product.images.push(`${values[_.image5]}.jpg`)

        if (this.products[product.product]) continue
        if (i) await this.newProduct(product)
        this.products[product.product] = true
      }
    },

    async newProduct (product) {
      const mutation = gqlProduct.NEW

      const variables = { product }

      const response = await gql.mutate(mutation, variables, false)

      console.log(response)

      if (response) {
        console.log(`The product '${product.product}' ha sido creado`)
      } else {
        console.log(`------------- The product '${location.location}' ha tenido un error al crearse`)
        console.log(response.error)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/integrations/Products.vue